<form [formGroup]="frm" class="formGroup">
  <mat-form-field>
    <mat-label>Tipo de vehículo</mat-label>
    <mat-select formControlName="vehicleType" #firstInput>
      @for(type of vehicleTypes; track type.id){
      <mat-option value="{{ type.id }}">{{ type.name }}</mat-option>
      }
    </mat-select>
    @if(vehicleType.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Color</mat-label>
    <mat-select formControlName="color">
      @for(color of colors; track color.value){
      <mat-option value="{{ color.value }}">{{ color.label }}</mat-option>
      }
    </mat-select>
    @if(color.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Marca</mat-label>
    <input matInput formControlName="mark" />
    @if(mark.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Modelo</mat-label>
    <input matInput formControlName="model" />
    @if(model.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Número de matrícula</mat-label>
    @if(plate.errors){
    <mat-hint>Formato: Una letra y 5 números</mat-hint>
    }
    <input matInput formControlName="plate" maxlength="6"/>
    @if(plate.hasError('required')){
    <mat-error> Campo requerido </mat-error>
    } @else if(plate.hasError('pattern')){
    <mat-error>Formato requerido: Una letra y 5 números</mat-error>
    }
  </mat-form-field>
</form>
